<div class="spinner">
  <div class="bounce1" [ngClass]="className"></div>
  <div class="bounce2" [ngClass]="className"></div>
  <div class="bounce3" [ngClass]="className"></div>
</div>
